var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex header-selection-main",
      staticStyle: { "align-items": "center" },
      attrs: { id: "header-right" },
    },
    [
      _c(
        "md-button",
        {
          directives: [
            {
              name: "tippy",
              rawName: "v-tippy",
              value: {
                followCursor: true,
                placement: "bottom-end",
                theme: _vm.isDarkMode ? "light-border" : "google",
              },
              expression:
                "{\n                followCursor: true,\n                placement: 'bottom-end',\n                theme: isDarkMode ? 'light-border' : 'google',\n            }",
            },
          ],
          staticClass: "custom-button header-btn",
          attrs: {
            content: _vm.isDarkMode
              ? _vm.$t("message.nightModeOn")
              : _vm.$t("message.nightModeOff"),
          },
          on: { click: _vm.toggleDarkMode },
        },
        [
          _c(
            "md-icon",
            { style: { color: _vm.darkMode ? "yellow" : "black" } },
            [_vm._v("wb_incandescent")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isAdmin && _vm.settings.privateChatEnabled
        ? _c(
            "div",
            { staticStyle: { position: "relative" } },
            [
              _c(
                "md-button",
                {
                  staticClass: "custom-button",
                  attrs: { "data-v-step": "3" },
                  on: {
                    click: function ($event) {
                      return _vm.toggleChat()
                    },
                  },
                },
                [_c("Chats")],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-popover",
        {
          attrs: {
            id: "popoverHelpMenu",
            "data-v-step": "4",
            placement: "bottom",
            title: "",
            trigger: "click",
          },
          model: {
            value: _vm.popovers.isHelpMenuPopoverOpen,
            callback: function ($$v) {
              _vm.$set(_vm.popovers, "isHelpMenuPopoverOpen", $$v)
            },
            expression: "popovers.isHelpMenuPopoverOpen",
          },
        },
        [
          _c("template", { slot: "content" }, [
            _c(
              "div",
              { attrs: { id: "popoverHelpMenuOpened" } },
              [
                !_vm.isAdmin
                  ? _c("div", { staticClass: "d-flex flex-row" }, [
                      _c(
                        "div",
                        { staticClass: "justify-content-start" },
                        [_c("show-intro")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "justify-content-end pl-3 popoverFont cursorPointer",
                          on: { click: _vm.showIntro },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("message.showIntro")) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isAdmin
                  ? _c("div", { staticClass: "d-flex flex-row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "justify-content-start" },
                        [_c("color-meaning")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "justify-content-end pl-3 popoverFont cursorPointer",
                          on: {
                            click: function ($event) {
                              return _vm.toggleChatColorModal(true)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("message.showChatColorMeaning")) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isAdmin
                  ? _c("div", { staticClass: "d-flex flex-row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "justify-content-start" },
                        [_c("keyboard")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "justify-content-end pl-3 popoverFont cursorPointer",
                          on: {
                            click: function ($event) {
                              return _vm.toggleKeyboardShotcutModal(true)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("message.keyboardShortcuts")) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isAdmin
                  ? _c(
                      "div",
                      {
                        staticClass: "d-flex flex-row",
                        staticStyle: {
                          "margin-top": "10px",
                          "margin-bottom": "-10px",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "justify-content-start" },
                          [_c("NewIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "justify-content-end pl-3 popoverFont cursorPointer",
                            on: { click: _vm.openNewsModal },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message.news")) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("NewsModal", { ref: "newsModal" }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-row mt-3 mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "justify-content-start" },
                    [
                      _c(
                        "md-icon",
                        {
                          staticStyle: {
                            color: "red",
                            width: "20px !important",
                            "min-width": "20px !important",
                            height: "20px !important",
                            "font-size": "20px !important",
                          },
                        },
                        [_vm._v("support\n                            ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "justify-content-end pl-3 popoverFont cursorPointer",
                      on: { click: _vm.integrationInstruction },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("message.notIntegrated")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: {
                      "d-flex flex-row mt-3": !_vm.isAdmin,
                      "d-flex flex-row": _vm.isAdmin,
                    },
                  },
                  [
                    _c("div", { staticClass: "justify-content-start" }, [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons",
                          staticStyle: { "font-size": "20px !important" },
                        },
                        [_vm._v("help_center")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "justify-content-end pl-3 popoverFont cursorPointer",
                        on: { click: _vm.connectSupportTeamRequest },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("message.supportUs")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: {
                      "d-flex flex-row mt-3": !_vm.isAdmin,
                      "d-flex flex-row": _vm.isAdmin,
                    },
                  },
                  [
                    _c("div", { staticClass: "justify-content-start" }, [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons",
                          staticStyle: { "font-size": "20px !important" },
                        },
                        [_vm._v("help_center")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "justify-content-end pl-3 popoverFont cursorPointer",
                        on: {
                          click: function ($event) {
                            return _vm.openPDF()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("message.help")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("AnnouncementNotifications"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: {
                      "d-flex flex-row mt-2": !_vm.isAdmin,
                      "d-flex flex-row": _vm.isAdmin,
                    },
                  },
                  [
                    _c("div", { staticClass: "justify-content-start" }, [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons",
                          staticStyle: { "font-size": "20px !important" },
                        },
                        [_vm._v("done")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "justify-content-end pl-3 popoverFont" },
                      [_vm._v("SUPSIS " + _vm._s(_vm.version.versionStr))]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "custom-button",
              class: { infoLight: _vm.unreadAnnouncements },
            },
            [
              _vm.unreadAnnouncements
                ? _c(
                    "a-badge",
                    { attrs: { color: "#F64E60" } },
                    [_c("Question")],
                    1
                  )
                : _c("Question"),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "a-popover",
            {
              attrs: {
                id: "settingsMenu",
                "data-v-step": "5",
                placement: "bottom",
                title: "",
                trigger: "click",
              },
              model: {
                value: _vm.popovers.isSettingPopoverOpen,
                callback: function ($$v) {
                  _vm.$set(_vm.popovers, "isSettingPopoverOpen", $$v)
                },
                expression: "popovers.isSettingPopoverOpen",
              },
            },
            [
              _c(
                "template",
                { slot: "content" },
                [
                  !_vm.isOpenLang
                    ? _c("div", { staticClass: "generalSetting" }, [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex flex-row mt-1",
                            staticStyle: { "align-items": "center" },
                            on: {
                              click: function ($event) {
                                _vm.isOpenLang = !_vm.isOpenLang
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "justify-content-start" },
                              [
                                _c("country-flag", {
                                  class: {
                                    selected:
                                      _vm.language.code === _vm.$i18n.locale,
                                  },
                                  attrs: {
                                    country:
                                      _vm.language.code === "en"
                                        ? "us"
                                        : _vm.language.code === "ar"
                                        ? "sa"
                                        : _vm.language.code,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "justify-content-end pl-3 cursorPointer popoverFont",
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("message.changeLang")) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.isAdmin
                          ? _c("div", { staticClass: "d-flex flex-row mt-3" }, [
                              _c(
                                "div",
                                { staticClass: "justify-content-start" },
                                [_c("UserName")],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "justify-content-end pl-3 popoverFont cursorPointer",
                                  on: {
                                    click: function () {
                                      return _vm.setModalVisible(
                                        true,
                                        "InSetting"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm.isVisibleRepresentativeModalInSetting
                                    ? _c(
                                        "a-modal",
                                        {
                                          staticClass: "representativeSettings",
                                          staticStyle: { top: "20px" },
                                          attrs: {
                                            destroyOnClose: true,
                                            footer: null,
                                            title: _vm.$t(
                                              "message.represantativeSettings"
                                            ),
                                            visible: _vm.modalVisible,
                                            width: 700,
                                          },
                                          on: {
                                            cancel: function () {
                                              return _vm.setModalVisible(false)
                                            },
                                          },
                                        },
                                        [_c("RepresentativeSettings")],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t("message.represantativeSettings")
                                      ) +
                                      "\n                            "
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pt-2 popoverFont justify-content-end popoverFont cursorPointer",
                              staticStyle: {
                                display: "inline-flex",
                                "align-items": "center",
                                cursor: "pointer",
                              },
                              on: { click: _vm.showModal },
                            },
                            [
                              _c("a-icon", {
                                staticClass: "mr-3",
                                staticStyle: {
                                  "font-size": "18px",
                                  color: "#48b6e7",
                                },
                                attrs: { type: "file-pdf" },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "font-size": "14px" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.supsisDocument"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "pt-2 popoverFont" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("message.fontSizeSetting")) +
                                "\n                            "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "div",
                            [
                              _c("a-slider", {
                                attrs: {
                                  max: _vm.zoomMaxRangeBound,
                                  min: _vm.zoomMinRangeBound,
                                  step: 5,
                                  value: _vm.zoomValue,
                                },
                                on: {
                                  change: function (value) {
                                    return (this$1.zoomValue = value)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "d-flex flex-row" }, [
                          _c("div", { staticClass: "justify-content-start" }, [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                  },
                                ],
                                style: {
                                  color: _vm.isDarkMode ? "#fff" : "#000",
                                },
                                attrs: {
                                  content: _vm.offlineMode
                                    ? _vm.$t("message.visitorScreen")
                                    : _vm.$t("message.visitorScreen"),
                                  href: _vm.visitorScreenUrl,
                                  target: "_blank",
                                },
                              },
                              [
                                _c(
                                  "md-icon",
                                  { staticStyle: { color: "#369afe" } },
                                  [_vm._v("preview")]
                                ),
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.$t("message.visitorScreen")) +
                                    "\n                                "
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        !_vm.isAdmin
                          ? _c("div", { staticClass: "d-flex flex-row" }, [
                              _c(
                                "div",
                                { staticClass: "justify-content-start" },
                                [
                                  _c(
                                    "md-switch",
                                    {
                                      staticClass: "md-primary",
                                      model: {
                                        value: _vm.shortcutReminderEnabled,
                                        callback: function ($$v) {
                                          _vm.shortcutReminderEnabled = $$v
                                        },
                                        expression: "shortcutReminderEnabled",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.shortcutReminder
                                              ? _vm.$t("message.showHint")
                                              : _vm.$t("message.dontShowHint")
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _c(
                        "div",
                        { staticClass: "langSetting" },
                        _vm._l(_vm.languages, function (language, index) {
                          return _c(
                            "div",
                            {
                              key: "lang-" + index,
                              staticClass: "d-flex flex-row",
                              staticStyle: {
                                "align-items": "center",
                                "border-top": "1px solid #eef0f8",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setCurrentLanguage(language.code)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "justify-content-start" },
                                [
                                  _c("country-flag", {
                                    class: {
                                      selected:
                                        language.code === _vm.$i18n.locale,
                                    },
                                    attrs: {
                                      country:
                                        language.code === "en"
                                          ? "us"
                                          : language.code === "ar"
                                          ? "sa"
                                          : language.code,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "justify-content-end pl-3 cursorPointer popoverFont",
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(language.name) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                  _vm._v(" "),
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "a-modal",
                          {
                            staticClass: "custom-modal",
                            attrs: {
                              visible: _vm.visible,
                              "cancel-text": null,
                              width: 1150,
                              footer: false,
                              "footer-hide": true,
                            },
                            on: {
                              "update:visible": function ($event) {
                                _vm.visible = $event
                              },
                              ok: _vm.handleOk,
                              cancel: function ($event) {
                                _vm.visible = false
                              },
                            },
                          },
                          [
                            _c("div", { staticStyle: { height: "700px" } }, [
                              _c("iframe", {
                                staticStyle: {
                                  width: "100%",
                                  height: "100%",
                                  border: "none",
                                },
                                attrs: { src: "https://doc.supsis.live/" },
                              }),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "md-button",
                { staticClass: "custom-button" },
                [_c("Settings")],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-selection-item",
          staticStyle: { padding: "0", "margin-left": "8px" },
        },
        [
          _c(
            "a-popover",
            {
              attrs: {
                id: "profileMenu",
                "data-v-step": "6",
                placement: "bottomLeft",
                title: "",
                trigger: "click",
              },
              model: {
                value: _vm.popovers.isProfileMenuPopoverOpen,
                callback: function ($$v) {
                  _vm.$set(_vm.popovers, "isProfileMenuPopoverOpen", $$v)
                },
                expression: "popovers.isProfileMenuPopoverOpen",
              },
            },
            [
              _c("template", { slot: "content" }, [
                _vm.user
                  ? _c("div", { staticClass: "d-flex flex-row" }, [
                      _c(
                        "div",
                        { staticClass: "justify-content-start" },
                        [_c("online")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "justify-content-end pl-3 popoverFont cursorPointer",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.setStatus("Online")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("message.online")) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-row mt-3" }, [
                  _c(
                    "div",
                    { staticClass: "justify-content-start" },
                    [_c("away")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "justify-content-end pl-3 popoverFont cursorPointer",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setStatus("Away")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("message.beRightBack")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-row mt-3" }, [
                  _c(
                    "div",
                    { staticClass: "justify-content-start" },
                    [_c("busy")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "justify-content-end pl-3 popoverFont cursorPointer",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setStatus("Busy")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("message.busy")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-row mt-3" }, [
                  _c(
                    "div",
                    { staticClass: "justify-content-start" },
                    [_c("offline")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "justify-content-end pl-3 popoverFont cursorPointer",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setStatus("Offline")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("message.offline")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                !_vm.isAdmin
                  ? _c("div", { staticClass: "d-flex flex-row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "justify-content-start" },
                        [_c("UserName")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "justify-content-end pl-3 popoverFont cursorPointer",
                          on: {
                            click: function () {
                              return _vm.setModalVisible(true, "InExitMenu")
                            },
                          },
                        },
                        [
                          _vm.isVisibleRepresentativeModalInExitMenu
                            ? _c(
                                "a-modal",
                                {
                                  staticClass: "representativeSettings",
                                  staticStyle: { top: "20px" },
                                  attrs: {
                                    destroyOnClose: true,
                                    footer: null,
                                    title: _vm.$t(
                                      "message.represantativeSettings"
                                    ),
                                    visible: _vm.modalVisible,
                                    width: 700,
                                  },
                                  on: {
                                    cancel: function () {
                                      return _vm.setModalVisible(false)
                                    },
                                  },
                                },
                                [_c("RepresentativeSettings")],
                                1
                              )
                            : _vm._e(),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("message.represantativeSettings")) +
                              "\n                        "
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-row mt-3" }, [
                  _c(
                    "div",
                    { staticClass: "justify-content-start" },
                    [_c("logout")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "justify-content-end pl-3 popoverFont cursorPointer",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.logout.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("message.logout")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.user
                ? _c("a", [
                    _c("div", { staticClass: "avatarSection" }, [
                      _c("span", { staticStyle: { "margin-right": "10px" } }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.user.name.charAt(0).toUpperCase() +
                                _vm.nameSorter(_vm.user.name.slice(1))
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "avatar",
                          class: _vm.user.status.toLowerCase(),
                        },
                        [
                          !_vm.user.gravatar && !_vm.gravatar
                            ? _c("a-avatar", {
                                staticClass: "avatar",
                                attrs: {
                                  size: 24,
                                  icon: "user",
                                  username: _vm.user.name,
                                  round: false,
                                  "background-color": "",
                                },
                              })
                            : _vm.user.gravatar || _vm.gravatar
                            ? _c("img", {
                                attrs: {
                                  src: _vm.user.gravatar || _vm.gravatar,
                                  alt: _vm.user.name,
                                },
                              })
                            : _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.user.name.substr(0, 1).toUpperCase()
                                  )
                                ),
                              ]),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-selection-item" },
        [
          _vm.adminUser
            ? _c(
                "b-dropdown",
                {
                  staticClass: "h-100",
                  attrs: {
                    id: "user-dropdown",
                    text: _vm.adminUser.email,
                    right: "",
                  },
                },
                [
                  _c("template", { slot: "button-content" }, [
                    _c("img", {
                      staticClass: "rounded-circle mx-1",
                      attrs: {
                        alt: "Kullanıcı resmi",
                        src: "https://placeimg.com/30/30/people",
                      },
                    }),
                    _vm._v(" "),
                    _c("small", [_vm._v(_vm._s(_vm.adminUser.name))]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    {
                      staticClass: "mt-2",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.logout.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-2",
                        attrs: { icon: "sign-out-alt" },
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("message.logout")) +
                          "\n                "
                      ),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              attrs: {
                id: "conversation-color-help2",
                footer: null,
                title: _vm.$t("message.chatColorMeanings"),
                visible: _vm.chatColorModalVisible,
              },
              on: {
                cancel: function ($event) {
                  return _vm.toggleChatColorModal(false)
                },
                ok: function ($event) {
                  return _vm.toggleChatColorModal(false)
                },
              },
            },
            [_c("ConversationColorHelp")],
            1
          ),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              attrs: {
                id: "ShortcutModal",
                footer: null,
                title: _vm.$t("message.keyboardShortcuts"),
                visible: _vm.keyboardShortCutsModalVisible,
              },
              on: {
                cancel: function ($event) {
                  return _vm.toggleKeyboardShotcutModal(false)
                },
              },
            },
            [_c("KeyboardShortcuts")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }